/**
 * Beta access (SPEC §21 decision 106): invite codes and waitlist share codes have the same shape, 8 characters without
 * 0/O or 1/I/L (as the API makes them). Typed input is accepted in any case.
 */
const CODE = /^[A-HJ-KM-NP-Z2-9]{8}$/;

/** Upper-cased and trimmed; null unless it has a code's shape. */
export function cleanCode(raw: string | null | undefined): string | null {
  const c = (raw ?? '').trim().toUpperCase();
  return CODE.test(c) ? c : null;
}
